export default "__VITE_ASSET__aPr753qP__"